let envSource;

if (process.env.NODE_ENV === 'development') {
  console.log('process.env.NODE_ENV', process.env.NODE_ENV);
  envSource = process.env;
} else {
  envSource = window.__env__;
}

const {
  REACT_APP_ACCOUNTS_URL,
  REACT_APP_B2B_SELFCARE_KEYCLOAK_REALM,
  REACT_APP_B2B_SELFCARE_KEYCLOAK_URL,
  REACT_APP_B2B_SELFCARE_KEYCLOAK_CLIENT_ID
} = envSource;

export default {
  accountsUrl: REACT_APP_ACCOUNTS_URL,
  keycloak: {
    realm: REACT_APP_B2B_SELFCARE_KEYCLOAK_REALM,
    url: REACT_APP_B2B_SELFCARE_KEYCLOAK_URL,
    clientId:REACT_APP_B2B_SELFCARE_KEYCLOAK_CLIENT_ID
  }
};
